/* eslint-disable */
import get from 'lodash.get';

export const STATE_KEY = 'leads';

export const getLeadError = (state) => get(state, [STATE_KEY, 'error']);
export const isLeadSubmitSuccessful = (state) => get(state, [STATE_KEY, 'submitted']);
export const isLeadSubmitting = (state) => get(state, [STATE_KEY, 'submitting']);
export const getLeadResponse = (state) => get(state, [STATE_KEY, 'response']);
export const getLeadRequest = (state) => get(state, [STATE_KEY, 'request']);
export const getLeadId = (state) => get(state, [STATE_KEY, 'response', 'leadsId']);

/* eslint-enable */




/** WEBPACK FOOTER **
 ** ./src/redux/selectors/leads.js
 **/